module.exports = __webpack_public_path__ + "static/img/2areaB_38.56d4432.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/2areaB_38.png
// module id = 1155
// module chunks = 1